import React from 'react';

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { IconButton } from 'components/IconButton';

interface PropsType {
	href: string;
	download?: string;
}

function DownloadButton({ href, download }: PropsType) {
	return (
		// @ts-expect-error
		<IconButton href={href} download={download} target="_blank" color="info">
			<SaveAltIcon />
		</IconButton>
	);
}

export default DownloadButton;
